import { render, staticRenderFns } from "./externalEntityViewData.vue?vue&type=template&id=9861904c&scoped=true"
import script from "./externalEntityViewData.vue?vue&type=script&lang=js"
export * from "./externalEntityViewData.vue?vue&type=script&lang=js"
import style0 from "./externalEntityViewData.vue?vue&type=style&index=0&id=9861904c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9861904c",
  null
  
)

export default component.exports